var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.6,
    height: 28,
    viewBox: "0 0 19.6 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Site_Management",
    "data-name": "Site Management",
    d: "M17.3,3a9.793,9.793,0,0,0-9.8,9.8c0,7.35,9.8,18.2,9.8,18.2s9.8-10.85,9.8-18.2A9.793,9.793,0,0,0,17.3,3Zm0,13.3a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,17.3,16.3Z",
    transform: "translate(-7.5 -3)",
    fill: "#f4f40e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteManagement);
export default __webpack_public_path__ + "static/media/Site Management.8774405481e049efabbaf58d4b602da4.svg";
export { ForwardRef as ReactComponent };